import { isElementType } from "@testing-library/user-event/dist/utils";
import React from "react";
import { config } from "../../../data/config";

function Languages() {
  const { Languages, WebDevelopement } = config;
  const langs = [...Languages, ...WebDevelopement];
  return (
    <div className="border-t border-gray-200 text-gray-700 body-font">
      <div className="container mx-auto py-6">
        <p className="font-bold mb-4 text-black text-2xl text-center">
          <span
            style={{
              backgroundImage:
                "linear-gradient(120deg, #84fab0 0%, #6366f1 100%)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 0.2em",
              backgroundPosition: "0 88%",
              transition: "background-size 0.25s ease-in",
            }}
            className="dark:text-white"
          >
            Languages and Technologies
          </span>
        </p>
        <p className="text-center text-sm dark:text-slate-400">Some Technologies and Languages I'm familiare with : </p>
        <div className="flex flex-wrap m-4">
          {langs.map((el , idx) => (
            <div className="p-4 w-1/2 md:w-1/4" key={idx}>
              <div className="flex-1 rounded-lg  h-full bg-gray-100 dark:bg-slate-800 dark:border-gray-500 dark:border p-4 flex-col">
                <div className="flex items-center mb-1">
                  <div className="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-indigo-500 text-white flex-shrink-0">
                   <i className={`${el.icon} rounded-full text-white`}></i>
                  </div>
                  <h2 className="text-gray-900 text-lg title-font font-medium dark:text-slate-200">
                    {el.lang}
                  </h2>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Languages;
